import './Notifications.scss';
import "react-toastify/dist/ReactToastify.css";
import React from "react";
import { toast, ToastContainer } from "react-toastify";
import { useTracked } from "../../state";

const Notifications: React.FC = () => {
    const [state] = useTracked();

    React.useEffect(() => {
        if (state.notification && state.notification.content) {
          const { type, content, processId, ...props } = state.notification;

          switch (type) {
            case 'info': {
              toast.info(content, props);
              break;
            }
            case 'success': {
              toast.success(content, props);
              break;
            }
            case 'warning': {
              toast.warn(content, props);
              break;
            }
            case 'error': {
              toast.error(content, props);
              break;
            }
            default: {
              toast.dark(content, props);
              break;
            }
          }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.notification]);

    return (
      <React.Fragment>
          <ToastContainer 
            newestOnTop={true} 
            draggable
            hideProgressBar 
            pauseOnFocusLoss={false} 
            pauseOnHover={false} 
          />
      </React.Fragment>
    )
}

export default Notifications;